import axios from 'axios'
export const baseURL = process.env.REACT_APP_API_URL;
const SBoardId = window.location.pathname.split('/').pop()
export const $api = axios.create({
    baseURL,
    headers: { SBoardId },
    withCredentials: true
})
